module.exports = __webpack_public_path__ + "kendoui.2d27c2be554d3acb53ac.woff";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/images/kendoui.woff?v=1.1
// module id = ../../../../../external_css/kendo-ui/images/kendoui.woff?v=1.1
// module chunks = styles